// extracted by mini-css-extract-plugin
export var label = "_es-2";
export var slideContainer = "_es-0";
export var slider = "_es-1";